import { PROMPT_EXAMPLE_IMAGE_LABELS } from "./prompts";

/** Static files in /public/prompt-examples (copied at build). */
export const PROMPT_EXAMPLE_IMAGE_URLS = [
  "/prompt-examples/gc.png",
  "/prompt-examples/covid.png",
  "/prompt-examples/camera-roll.png",
  "/prompt-examples/woke-up.png",
  "/prompt-examples/flowers.png",
  "/prompt-examples/instagram-draft.png",
] as const;

/** Same order as `PROMPT_EXAMPLE_IMAGE_URLS`; sourced from `prompts.ts` for a single copy. */
export const PROMPT_TEXT_BY_EXAMPLE_IMAGE_INDEX: readonly string[] =
  PROMPT_EXAMPLE_IMAGE_LABELS;

/** Prompt copy must match `prompts.ts` exactly. Value = index in PROMPT_EXAMPLE_IMAGE_URLS. */
export const PROMPT_TEXT_TO_EXAMPLE_IMAGE_INDEX: Record<string, number> =
  Object.fromEntries(
    PROMPT_EXAMPLE_IMAGE_LABELS.map((text, i) => [text, i]),
  );

export function getExampleImageIndexForPrompt(text: string): number | undefined {
  return PROMPT_TEXT_TO_EXAMPLE_IMAGE_INDEX[text];
}

export function getPromptTextForExampleImageIndex(index: number): string | undefined {
  if (index < 0 || index >= PROMPT_EXAMPLE_IMAGE_LABELS.length) return undefined;
  return PROMPT_EXAMPLE_IMAGE_LABELS[index];
}
